module.exports = __webpack_public_path__ + "img/hyl_p2.51020d1c.png";